// firebase
import { db } from "config/firebase";
import { collection, setDoc, doc } from "firebase/firestore";

// features/user
import addSignature from "features/user/addSignature";

// A ---------------------------------------------------------------------- M

const sendDataStream = async (isPublic, userID, dataBody, dataCertification, timestamp, databoxID) => {
  try {
    const txid = dataCertification.txid;
    const recordRef = doc(db, "recordsdata", txid);

    const recordData = {
      txid,
      type: "doc",
      ...(databoxID && { tdr: databoxID }),
      creator_uuid: userID,
      public: isPublic,
      version: 1,
      timestamp,
      fileName: dataBody.fileName,
      fileType: dataBody.fileType,
      description: dataBody.comment,
      data: {
        fileName: dataBody.fileName,
        fileType: dataBody.fileType,
        storagePath: dataBody.storagePath,
        comment: dataBody.comment,
        timestamp,
      },
    };

    await setDoc(recordRef, recordData);
    console.log("Record data saved:", recordData);

    if (databoxID) {
      const tagRef = doc(db, "tagsdata", databoxID);
      const recordsRef = collection(tagRef, "signatures");

      const signatureData = {
        txid,
        type: "doc",
        creator_uuid: userID,
        public: isPublic,
        db_id: 1,
        timestamp,
        fileName: dataBody.fileName,
        fileType: dataBody.fileType,
        description: dataBody.comment,
      };

      console.log("Signature data to save:", signatureData);
      await setDoc(doc(recordsRef, txid), signatureData);
    }

    databoxID ? await addSignature(userID, txid, timestamp, "doc", databoxID) : await addSignature(userID, txid, timestamp, "doc");

    const result = {
      txid: txid,
      success: true,
    };

    console.log(result);
    return result;
  } catch (err) {
    console.error("Error in sendDataStreamDoc:", err);
    return {
      success: false,
      error: err.message,
    };
  }
};

export default sendDataStream;
